import { z } from "zod";
import { ArrowConnector } from "./distributors/arrow";
import { DigikeyConnector } from "./distributors/digikey/connector";
import { LCSCConnector } from "./distributors/lcsc";
import { MouserConnector } from "./distributors/mouser";
import { TMEConnector } from "./distributors/tme";
import { VericalConnector } from "./distributors/verical";
export const distributorUids = ["digikey", "lcsc", "mouser", "arrow", "verical", "tme"];
/**
 * Centralized registry of distributors
 */
export const distributorRegistry = [
    {
        uid: "digikey",
        displayName: "Digi-Key",
    },
    {
        uid: "lcsc",
        displayName: "LCSC",
    },
    {
        uid: "mouser",
        displayName: "Mouser",
    },
    {
        uid: "arrow",
        displayName: "Arrow",
    },
    {
        uid: "verical",
        displayName: "Verical",
    },
    {
        uid: "tme",
        displayName: "TME",
    },
];
/**
 * Map of distributor IDs to connector classes
 */
export const connectorClasses = {
    digikey: DigikeyConnector,
    lcsc: LCSCConnector,
    mouser: MouserConnector,
    arrow: ArrowConnector,
    verical: VericalConnector,
    tme: TMEConnector,
};
/**
 * Generate the DistributorIdentifierEnum from the registry
 */
export const DistributorIdentifierEnum = z.enum(distributorUids);
/**
 * Get distributor info from the registry
 */
export const getDistributorInfo = () => {
    return distributorRegistry.reduce((acc, entry) => {
        acc[entry.uid] = { name: entry.displayName };
        return acc;
    }, {});
};
//# sourceMappingURL=registry.js.map